<template>
  <div class="privacy">
    <div class="header"></div>
    <div class="body container">
      <div class="content">
        <div class="c-modal-header">
          <img
            src="https://firebasestorage.googleapis.com/v0/b/rahal-7e911.appspot.com/o/public%2FlandingPage%2Frahal-logo.webp?alt=media&token=62ea1dfb-20b9-4541-aa4d-442d6e1e737c"
          />
          <div class="title">
            <h5>
              {{ $t('common.termsAnd') }}
              {{ $t('common.conditions') }}
            </h5>
          </div>

          <div @click="close">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="1em"
              viewBox="0 0 384 512"
            >
              <path
                d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
              />
            </svg>
          </div>
        </div>
        <div class="content-body">
          <div>
            <p>
              <app-i18n
                code="termsAndConditions.p_1"
              ></app-i18n>
            </p>
            <p>
              <app-i18n
                code="termsAndConditions.p_2"
              ></app-i18n>
            </p>
            <p>
              <app-i18n
                code="termsAndConditions.p_3"
              ></app-i18n>
            </p>
            <div>
              <p>
                <app-i18n
                  code="termsAndConditions.p_4"
                ></app-i18n>
              </p>
              <p>
                <app-i18n
                  code="termsAndConditions.p_5"
                ></app-i18n>
              </p>
              <ul>
                <li>
                  <a
                    href="https://www.google.com/policies/privacy/"
                    target="_blank"
                    >Google Play Services</a
                  >
                </li>
                <li>
                  <a
                    href="https://firebase.google.com/policies/analytics"
                    target="_blank"
                    >Google Analytics for Firebase</a
                  >
                </li>
                <li>
                  <a
                    href="https://firebase.google.com/support/privacy/"
                    target="_blank"
                    >Firebase Crashlytics</a
                  >
                </li>
                <li>
                  <a
                    href="https://twitter.com/en/privacy"
                    target="_blank"
                    >Twitter</a
                  >
                </li>
                <li>
                  <a
                    href="https://www.facebook.com/about/privacy/update/printable"
                    target="_blank"
                    >Facebook</a
                  >
                </li>
              </ul>
            </div>
            <p>
              <app-i18n
                code="termsAndConditions.p_6"
              ></app-i18n>
            </p>
            <p></p>
            <p>
              <app-i18n
                code="termsAndConditions.p_7"
              ></app-i18n>
            </p>
            <p>
              <app-i18n
                code="termsAndConditions.p_8"
              ></app-i18n>
            </p>
            <p>
              <app-i18n
                code="termsAndConditions.p_9"
              ></app-i18n>
            </p>
            <p>
              <app-i18n
                code="termsAndConditions.p_10"
              ></app-i18n>
            </p>
            <p>
              <strong>
                <app-i18n
                  code="termsAndConditions.p_11"
                ></app-i18n>
              </strong>
            </p>
            <p>
              <app-i18n
                code="termsAndConditions.p_12"
              ></app-i18n>
            </p>
            <p>
              <app-i18n
                code="termsAndConditions.p_13"
              ></app-i18n>
            </p>
            <p>
              <strong>
                <app-i18n
                  code="termsAndConditions.p_14"
                ></app-i18n>
              </strong>
            </p>
            <p>
              <app-i18n
                code="termsAndConditions.p_15"
              ></app-i18n>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
export default {
  methods: {
    close() {
      window.close();
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.privacy {
  display: flex;
  flex-direction: column;
  background: rgba(255, 98, 135, 0.024);
  overflow: hidden !important;
  height: 100dvh;
}

.header {
  background: linear-gradient(
    180deg,
    #ff6286ff,
    #ff5e84ff,
    #ff5a81ff,
    #ff567fff,
    #ff527cff,
    #ff4e7aff,
    #ff4a77ff
  );
  height: 35dvh;
}
.body {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.content {
  background: white;
  border-radius: 10px;
  padding: 40px;
  filter: drop-shadow(0 25px 25px rgb(0 0 0 / 0.15));
}

.content-body {
  max-height: 65dvh;
  overflow-y: scroll !important;
  padding: 0px 15px;
  padding-top: 10px;
}

.c-modal-header {
  align-items: center;
  margin-bottom: 40px;
}
.c-modal-header img {
  width: 70px;
}
.c-modal-header .title {
  text-align: center;
}
.c-modal-header .title h5 {
  font-size: 30px !important;
  font-weight: 600 !important;
  color: #ff4a77ff;
}
.c-modal-header .title p {
  margin-bottom: 0px;
  margin-top: 10px;
  color: #afafaf;
}
.c-modal-header svg {
  font-size: 26px;
  cursor: pointer;
}
@media (width < 768px) {
  .content {
    padding: 25px;
  }
  .c-modal-header {
    margin-bottom: 20px;
    padding: 0px 10px;
  }

  .c-modal-header .title p {
    display: none;
  }
  .c-modal-header .title h5 {
    font-size: 18px !important;
    font-weight: 600 !important;
  }
  .c-modal-header img {
    width: 40px;
  }
  .c-modal-header svg {
    font-size: 20px;
    cursor: pointer;
  }
  .content-body {
    border-top: 1px solid #ebebeb;
  }
}
</style>
  
  
  
  <style lang="scss" scoped>
.layout-padding {
  padding: 40px;
}

.c-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.privacy-policy-title {
}

@media (max-width: 1200px) {
  .container,
  .container-lg,
  .container-md,
  .container-sm,
  .container-xl {
    max-width: 1140px !important;
  }
}

@media (max-width: 992px) {
  .container,
  .container-lg,
  .container-md,
  .container-sm {
    max-width: 960px !important;
  }
}

@media (max-width: 768px) {
  .container,
  .container-md,
  .container-sm {
    max-width: 720px !important;
  }
}

@media (max-width: 576px) {
  .container,
  .container-sm {
    max-width: 540px !important;
  }
}

@media (max-width: 1200px) {
  .container {
    max-width: 1140px !important;
  }
}

@media (max-width: 992px) {
  .container {
    max-width: 960px !important;
  }
}

@media (max-width: 768px) {
  .container {
    max-width: 720px !important;
  }
}

@media (max-width: 576px) {
  .container {
    max-width: 540px !important;
  }
}

@media (width > 1280px) {
  .container {
    max-width: 920px !important;
  }
}

/* width */
.content-body::-webkit-scrollbar {
  width: 8px;
}

/* Track */
.content-body::-webkit-scrollbar-track {
  background: #ff628711;
}

/* Handle */
.content-body::-webkit-scrollbar-thumb {
  background: linear-gradient(
    180deg,
    #ff6286ff,
    #ff5e84ff,
    #ff5a81ff,
    #ff567fff,
    #ff527cff,
    #ff4e7aff,
    #ff4a77ff
  );
  border-radius: 3px;
}

/* Handle on hover */
</style>
  
  